import { AdminConfig } from "./adminConfig.js";
import { DataConfig } from "./dataConfig.js";
import { Search } from "./search.js";
import { UserConfig } from "./userConfig.js";
import { WorkflowConfig } from "./workflowConfig.js";

const Config = [
  ...AdminConfig,
  ...DataConfig,
  ...Search,
  ...UserConfig,
  ...WorkflowConfig,
];

export default {
  Config,
};
